"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceAlignWithAligned = replaceAlignWithAligned;
// This replacement comes from Perseus:
// https://github.com/Khan/perseus/blob/5e21e267fa5a144036750b158292e4085c8a4298/packages/perseus/src/renderer.tsx#L1250
//
// In Perseus, it was originally intended to make our
// math content work with KaTeX, but it also turns out to be necessary for
// MathJax. The reason is that in MathJax, you cannot nest
// `\begin{align}...\end{align}` environments, but you *can* nest
// `\begin{aligned}...\end{aligned}`. Since our content contains nested
// `\begin{align}`, this replacement is necessary.
//
// Even though Perseus does this replacement for us, we also need to do it in
// our preprocessing pipeline because sometimes, TeX gets rendered by something
// other than Perseus (our tests, for example!)
function replaceAlignWithAligned(tex) {
    return tex.replace(/\{align[*]?}/g, "{aligned}");
}
